import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { motion } from 'framer-motion';
import './News.css';

const News = () => {
  const [news, setNews] = useState([]);
  const [visibleItems, setVisibleItems] = useState(3);

  useEffect(() => {
    // Fetch news data from the JSON file
    fetch('/News.json')
      .then((response) => response.json())
      .then((data) => setNews(data))
      .catch((error) => console.error('Error fetching news:', error));
  }, []);

  // Load more items
  const loadMore = () => {
    setVisibleItems((prev) => prev + 3);
  };

  // Animation variants
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <div className="container news-feed ">
            <div className="title-main text-center mx-auto mb-md-5 mb-4" style={{maxWidth:"700px"}}>
                <h5 className="small-title mb-2 pt-5">News Feed</h5>
                <h3 className="title-style">Latest Blog Posts</h3>
            </div>
      <div className="row">
        {news.slice(0, visibleItems).map((item, index) => (
          <motion.div
            key={item.id}
            className="col-md-6 col-lg-4 mb-4"
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            transition={{ delay: index * 0.2 }}
          >
            <div className="card news-card">
                <div className='h-48 overflow-hidden'>
                    {item.mediaType === 'video' ? (
                        <video
                        className='w-100 h-100 object-fit-contain'
                        controls
                        preload='metadata'
                        >
                        <source src={item.media} type='video/mp4' />
                        your browser not support the video
                        </video>
                    ):(
                        <img src={item.media} 
                        className='w-100 h-100 object-fit-cover' />
                    
                    )}
                </div>



              {/* <img
                src={item.image}
                className="card-img-top object-fit-contain mt-3"
                alt={item.title}
              /> */}
              <div className="card-body">
                <h5 className="card-title">{item.title}</h5>
                <p className="card-text">{item.description}</p>
                <p className="card-date">
                  <small className="text-muted">{item.date}</small>
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Load More Button */}
      {visibleItems < news.length && (
        <div className="text-center mt-4">
          <button onClick={loadMore} className="btn btn-style mb-4">
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default News;